<template>
  <div class="main">
    <nav-top></nav-top>
    <el-row type="flex" justify="center">
      <el-col :span="17" class="score_content">
        <el-row class="score_cc">
          <el-col :span="24" class="score_crumbs">
            您的位置：
            <a href="http://www.jssyyjxh.com">江苏省音乐家协会</a> > 成绩查询
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
                <tab-vue></tab-vue>
            </el-col>
          <el-col :span="20" style="padding-left:10px;">
            <score-vue></score-vue>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="box_footer">
      <p style="padding:10px 0;">省音协考级报名咨询电话 025-83572077</p>
      <p>苏ICP备：10064548号</p>
    </div>
  </div>
</template>
<script>
import navTop from "@/components/navTop";
import tabVue from "@/components/tabLeft";
import scoreVue from "@/components/score.vue";
export default {
  components: {
    tabVue,
    scoreVue,
    navTop
  },
  data() {
    return {};
  },
  created() {
    //  window.Global.checkToken()
  },
  methods: {}
};
</script>
<style lang="less">
.score_content {
  background: #fff;
  border: 1px solid #cbc6c0;
  border-top: 0;
  padding: 20px 15px;
  .score_cc {
    .score_crumbs {
      font-size: 12px;
      height: 40px;
      a {
        color: #666;
      }
    }
  }
}
</style>


   


// WEBPACK FOOTER //
// src/views/indexScore.vue